module.exports = __webpack_public_path__ + "img/LogoXbatt_Color.2905c24a.png";